module.exports = __webpack_public_path__ + "static/media/logo-stacked.a6bc6ee1.png";